import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { DynamicsCrmEntityDataset } from 'app/model/dataset/dynamics-crm.dataset';
import { DynamicsSink } from './dynamics.copysink';

@Metamodel.model({
    name: adfModelTypeMap.dynamicsCRM.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(DynamicsCrmEntityDataset) }
})
export class DynamicsCrmSink extends DynamicsSink {
}
